// extracted by mini-css-extract-plugin
module.exports =  {"shareButton":"shareButton___tBeZe","fbIcon":"fbIcon___JpTYk"};